function e() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
export {
  e as default
};
//# sourceMappingURL=canUseDom.mjs.map
